<template>
  <div>
    <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-select :options="listOfType" v-model="currentRowTechnicalParameters.type_id" :disabled="currentRowTechnicalParameters.id === Number(currentRowTechnicalParameters.id)"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Link ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-select :options="listOfLinkId" v-model="currentRowTechnicalParameters.slink_id" :disabled="currentRowTechnicalParameters.id === Number(currentRowTechnicalParameters.id)"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Parameter')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-input type="text" v-model="currentRowTechnicalParameters.param" :placeholder="$t('Fill in the field')"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-input type="text" v-model="currentRowTechnicalParameters.passwd"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Created on')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="currentRowTechnicalParameters.id" disabled>
      <b-form-input v-model="currentRowTechnicalParameters.reg_date"/>
    </b-form-group>

    <modal-ok-cancel @save="saveTechParam" @cancel="hideAddTechnicalParameters" />
  </div>
</template>

<script>

export default {
  props: {
    currentRow: null,
    selectedAccount: null,
    currentRowTechnicalParameters: null,
    listOfType: null,
    listOfLinkId: null
  },
  methods: {
    saveTechParam () {
      if (!this.currentRowTechnicalParameters.param) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in the field "Parameter"'), 'Error')
        return
      }
      if (this.currentRowTechnicalParameters.slink_id === 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select "Link ID"'), 'Error')
        return
      }
      let regdate = Number(Date.parse(this.currentRowTechnicalParameters.reg_date)) / 1000
      if (!regdate) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Failed created on date'), 'Error')
        return
      }
      this.currentRowTechnicalParameters.reg_date = regdate
      if (this.currentRowTechnicalParameters.id) {
        this.currentRowTechnicalParameters.tech_param_id = this.currentRowTechnicalParameters.id
      }
      let response = this.currentRowTechnicalParameters.id
        ? this.$store.dispatch('Users/UPDATE_TECH_PARAMS', this.currentRowTechnicalParameters)
        : this.$store.dispatch('Users/CREATE_TECH_PARAMS', this.currentRowTechnicalParameters)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          let payload = {
            user_id: this.currentRow.user_id,
            account_id: this.selectedAccount
          }
          this.$store.dispatch('Users/GET_TECH_PARAMS', payload)
          this.$root.$emit('makeToasts')
          this.$emit('hideAddTechnicalParameters')
        }
      })
    },
    hideAddTechnicalParameters () {
      this.$emit('hideAddTechnicalParameters')
    }
  },
  mounted () {
    if (this.currentRowTechnicalParameters.id) {
      this.currentRowTechnicalParameters.reg_date = this.$root.getMomentWithTZDelta(this.currentRowTechnicalParameters.reg_date).format('MM-DD-YYYY')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/technicalParameters/formAdd.vue